import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

/**
 * Aggregated mapping of every email address associated with a client.
 *
 * Mirrors `client_phone` but for emails (DD.12 prereq). The
 * Communications tab needs to find all email_record rows whose
 * from/to/cc match any address belonging to the client; this table is
 * the de-normalised source of truth for that join.
 *
 * v1 source of email is `client.email` only (one). v2 contributors
 * are `client.email` and `client_contact.email` for each contact.
 * Sync keeps the table in lockstep with both whenever either
 * upstream column changes — see `clientEmailSync.ts`. Addresses are
 * lower-cased to keep an exact-string join cheap regardless of how
 * the user typed them in.
 */
@Index('client_email_email_index', ['email'], {})
@Index('client_email_pk', ['fkClientId', 'email'], { unique: true })
@Entity('client_email')
export class ClientEmailEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'email', length: 255 })
	public email!: string;

	@ManyToOne(() => ClientEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
